
import { Outlet } from "react-router-dom";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { ErrorBoundary } from "@/components/admin/ErrorBoundary";
import { Suspense, lazy } from "react";

const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-[200px]">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
  </div>
);

const AdminLayout = () => {
  const isMobile = useIsMobile();

  return (
    <div className="flex min-h-screen w-full">
      {isMobile ? (
        <Sheet>
          <SheetTrigger asChild>
            <Button 
              variant="ghost" 
              size="icon" 
              className="fixed top-4 left-4 z-50"
            >
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-[80%] max-w-[300px]">
            <div className="h-full overflow-auto">
              <AdminSidebar />
            </div>
          </SheetContent>
        </Sheet>
      ) : (
        <div className="hidden md:block">
          <AdminSidebar />
        </div>
      )}
      <div className="flex-1 p-4 sm:p-6 md:ml-0 overflow-x-hidden">
        {isMobile && <div className="h-12"></div>} {/* Spacer for mobile menu button */}
        <ErrorBoundary>
          <Suspense fallback={<LoadingFallback />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default AdminLayout;
